<template>
  <div class="print"
       v-show="visible">
    <div class="print-box abs-center">
      <div class="closeBtn"
           @click="close"></div>
      <label class="title">{{language==='en'?'print':'打印'}}</label>
      <div class="print-label left"
           v-show="current">{{infos.print_leftPage}}</div>
      <div class="print-image abs-center"
           v-if="currentImg">
        <img :src="currentImg[current]" />
      </div>
      <div class="print-label right"
           v-show="!isLast">{{infos.print_rightPage}}</div>
      <div class="print-arrow left"
           @click="changePage(0)"
           v-show="current"></div>
      <div class="print-arrow right"
           @click="changePage(1)"
           v-show="!isLast"></div>
      <div class="print-btn"
           @click="print"
           :class="language==='en'?'en':'en'" />
    </div>
  </div>
</template>
<script>
import print from 'vue-print-nb';

export default {
  name: 'printview',
  props: {
    print_visible: Boolean,
    language: String,
    pages: Object,
  },
  data() {
    return {
      current: 0,
      scaleImage: '',
      printObj: {
        id: 'printImg',
        popTitle: 'good print',
      },
      infos: {
        print_leftPage: '选择打印左页',
        print_rightPage: '选择打印右页',
      },
    };
  },
  computed: {
    visible() {
      return this.print_visible;
    },
    isLast() {
      return this.current === this.currentImg.length - 1;
    },
    currentImg() {
      const arr = [];
      if (this.pages) {
        if (this.pages.leftPage) arr.push(this.pages.leftPage.smallurl);
        if (this.pages.rightPage) arr.push(this.pages.rightPage.smallurl);
        return arr;
      }
      return false;
    },
  },
  methods: {
    close() {
      this.$store.commit('updateView', {
        view: 'book',
      });
    },
    changePage(n) {
      this.current = n;
    },
    print() {
      // const el = '<p>aaaa</p>';
      const imageUri = this.currentImg[this.current].replace(/small/g, 'large');
      const iframe = document.createElement('IFRAME');
      iframe.setAttribute(
        'style',
        'position:absolute;width:0px;height:0px;left:-500px;top:-500px;',
      );
      document.body.appendChild(iframe);
      const doc = iframe.contentWindow.document;
      // doc.write(el);
      const ys = 'html,body{height:100%}img{max-width:100%;max-height:100%;margin:0 auto}';
      const style = document.createElement('style');
      style.innerText = ys;
      doc.getElementsByTagName('head')[0].appendChild(style);
      const image = new Image();
      image.src = imageUri;
      doc.getElementsByTagName('body')[0].appendChild(image);
      doc.close();
      image.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      };
    },
  },
  directives: {
    print,
  },
};
</script>
<style lang="less" scoped>
.print {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  z-index: 1000;
  &-box {
    width: 800px;
    height: 480px;
    background: #0b111c;
    border: 10px solid white;
    box-sizing: border-box;
    .title {
      font-size: 24px;
      left: 0px;
      position: absolute;
      color: white;
      margin: 10px 15px;
    }
    .print-arrow {
      width: 13px;
      height: 22px;
      position: absolute;
      background: url("~@/assets/icon/printLeftDisabled.png");
      cursor: pointer;
    }
    .print-arrow.left {
      position: absolute;
      margin: 202px 215px;
    }
    .print-arrow:hover {
      background: url("~@/assets/icon/printLeft.png");
    }
    .print-arrow.right {
      position: absolute;
      margin: 202px 545px;
      transform: rotate(-180deg);
    }
    .print-image {
      position: absolute;
      width: 270px;
      height: 360px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .closeBtn {
      width: 31px;
      height: 31px;
      position: absolute;
      right: 0px;
      margin-left: 390px;
      margin-top: 0px;
      background-image: url("~@/assets/icon/imgClose.jpg");
      cursor: pointer;
    }
    .print-label {
      position: absolute;
      width: 100px;
      left: 0;
      color: white;
    }
    .left {
      margin: 205px 110px;
    }
    .right {
      margin: 205px 560px;
    }
    .print-btn {
      background: url("~@/assets/icon/cn/print_print.png");
      width: 87px;
      height: 25px;
      right: 50px;
      position: absolute;
      bottom: 50px;
      cursor: pointer;
    }
  }
  .print-btn.en {
    background: url("~@/assets/icon/en/print_print.png");
  }
}
</style>
